export const HAZARD = 1;
export const COURSE_RECORD = 2;
export const EVENT_RECORD = 3;
export const ACCIDENT = 4;
export const HAZARD_REVIEW = 5;
export const HAZARD_LOGS = 6;
export const HAZARD_CONTROL = 7;
export const USER_LIBRARY = 8;

export default {
  HAZARD,
  COURSE_RECORD,
  EVENT_RECORD,
  ACCIDENT,
  HAZARD_REVIEW,
  HAZARD_LOGS,
  HAZARD_CONTROL,
  USER_LIBRARY
};
